export const TABLE_PAYROLL_INDEX = {
  PayrollID: "prid",
  Status: "status",
  Name: "employee_name",
  CompanyName: "coid",
  RequestAmount: "reqAmount",
  DisburseAmount: "nda",
  AdminFees: "fee",
  ApplicationReason: "reason",
  Loyalty: "loyaltyTier",
  BankName: "bankName",
  BankAcc: "bankAcc",
  BankPaymentFile: "rhbName",
  BillingID: "billid",
  BatchID: "batchID",
  UpdatedAt: "updatedAt",
  CreatedAt: "createdAt",
  Remarks: "remark",
};

export const TABLE_PAYROLL_TITLE = {
  PayrollID: "Payroll Advance ID",
  Status: "Status",
  Name: "Employee Name",
  Contact: "Employee Contact",
  IC: "Employee IC",
  Reference: "Employee Reference ID",
  CompanyName: "Company Name",
  CompanyId: "Company ID",
  RequestAmount: "Requested Amount",
  DisburseAmount: "Net Disbursement Amount",
  AdminFees: "Admin Fees",
  ApplicationReason: "Application Reason",
  Loyalty: "Loyalty",
  BankInformation: "Bank Info",
  BankName: "Bank Name",
  BankAcc: "Bank Account",
  BankHolderName: "Bank Holder Name",
  BankHolderIC: "Bank Holder IC",
  BankPaymentFile: "RHB Bank Payment File",
  BillingID: "Billing ID",
  BatchID: "Batch ID",
  UpdatedAt: "Last Updated By",
  CreatedAt: "Created By",
  Remarks: "Remarks",
};

export const PAYROLL_STATUS = {
  ready_for_processing: 1,
  on_hold: 2,
  bank_processing: 3,
  disbursed: 4,
  cancelled: 0,
};

export const PAYROLL_STATUS_TITLE = {
  [PAYROLL_STATUS.ready_for_processing]: {
    name: "Ready For Processing",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 1,
  },
  [PAYROLL_STATUS.on_hold]: {
    name: "On Hold",
    colorTag: "#959595",
    bgColor: "#F5F5F5",
    status: 2,
  },
  [PAYROLL_STATUS.bank_processing]: {
    name: "Bank Processing",
    colorTag: "#506DEE",
    bgColor: "#F1F4FF",
    status: 3,
  },
  [PAYROLL_STATUS.disbursed]: {
    name: "Disbursed",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 4,
  },
  [PAYROLL_STATUS.cancelled]: {
    name: "Cancelled",
    colorTag: "#FF0000",
    bgColor: "#FFF2F2",
    status: 0,
  },
};

export const groupOptions = (group) => {
  const groupOptions = group
    ? Object.values(group).map((g) => ({
        value: g.groupid,
        label: g.name,
      }))
    : [];

  return groupOptions;
};

export const filterOptions = [
  { value: "createdAt", label: "Created Date", type: "date" },
  { value: "prid", label: "Payroll Advance ID", type: "text" },
  { value: "employee_name", label: "Employee Name", type: "text" },
  { value: "company_name", label: "Company Name", type: "text" },
];

// Payroll File
export const PAYROLL_FILE_INDEX = {
  PaymentFile : "rhbName",
  Status : "status",
  TotalPayroll : "totalPayroll",
  TotalPaymentFile : "totalPaymentAmount",
  PayrollAdvanceSummary : "payrollAdvanceSummary",
  AssociatedCompany : "companyCountMap",
  GeneratedBy : "createdAt",
  Remarks : "remark",
}

export const PAYROLL_FILE_TITLE = {
  PaymentFile : "Payment File",
  Status : "Status",
  TotalPayroll : "Total payroll advance In File",
  TotalPaymentFile : "Total payment File Amount",
  PayrollAdvanceSummary : "Payroll Advance Summary",
  AssociatedCompany : "Associated Company",
  GeneratedBy : "Generated By",
  Remarks : "Remarks",
}

// Payroll File Expand Table
export const PAYROLL_FILE_EXPAND_INDEX = {
  PayrollID: "prid",
  Status: "status",
  Name: "employee_name",

}

export const PAYROLL_FILE_EXPAND_TITLE = {
  PayrollID: "Payroll Advance ID",
  Status: "Status",
  Name: "Employee Name",
  CompanyName: "Company Name",
  RequestAmount: "Requested Amount",
  DisburseAmount: "Net Disbursement Amount",
  AdminFees: "Admin Fees",
  Loyalty: "Loyalty",
  BankInformation: "Bank Info",
  UpdatedAt: "Last Updated By",
  CreatedAt: "Created By",
}

export const PAYROLL_FILE_STATUS = {
  open: 0,
  closed: 1,
};

export const PAYROLL_FILE_ISCLOSED = {
  [PAYROLL_FILE_STATUS.closed]: {
    name: "closed",
    colorTag: "#FFA800",
    bgColor: "#FFF5E0",
    status: 1,
  },
  [PAYROLL_FILE_STATUS.open]: {
    name: "open",
    colorTag: "#34C759",
    bgColor: "#DDFFE4",
    status: 0,
  },
};